import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Btn = styled.button`
  display: inline-block;
  margin: ${(props) => (props.margin ? props.margin : '0 5px')};
  border-radius: 0;
  font-size: ${(props) => props.theme.fontSize.larger};
  padding: 0.25em 2em;
  border: 0;
  background: ${(props) => props.theme.colors.primaryBackground};
  color: ${(props) => props.theme.colors.whiteText};
  cursor: pointer;
  outline: 0;
  width: ${(props) => (props.width ? props.width : 'auto')};
`;

const Button = ({ children, width, margin, onClick }) => (
  <Btn width={width} margin={margin} onClick={onClick}>
    {children}
  </Btn>
);

Button.defaultProps = {
  width: null,
  margin: null,
};

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  width: PropTypes.string,
  margin: PropTypes.string,
  onClick: PropTypes.func,
};

export default Button;
